import SocialMedia from '@features/footer/components/SocialMedia';
import styles from '@features/footer/Footer.styles';
import Contact from '@features/footer/components/Contact';
import { TSocialMedia } from '@features/footer/typescript';
import FooterNewsletter from '@features/footer/components/FooterNewsletter/FooterNewsletter';
type PropsType = {
  chatLink: string;
  phoneNr: string;
  socialMedia: TSocialMedia[];
  showNewsletter: boolean;
};
const ContactData = ({
  chatLink,
  socialMedia,
  phoneNr,
  showNewsletter
}: PropsType) => <div sx={styles.footerContactContainer(!showNewsletter, showNewsletter)}>
    {showNewsletter ? <div sx={styles.footerContactGridColumn}>
        <Contact chatLink={chatLink} phoneNr={phoneNr} />
      </div> : <Contact chatLink={chatLink} phoneNr={phoneNr} />}
    {showNewsletter && <FooterNewsletter />}
    {showNewsletter ? <div sx={styles.footerSocialGridColumn}>
        <SocialMedia media={socialMedia} />
      </div> : <SocialMedia media={socialMedia} />}
  </div>;
export default ContactData;